<template>
    <div id="app">
        <div class="modal fade" id="logoutWarning" tabindex="-1" role="dialog" aria-labelledby="logoutWarningTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Session Timeout</h5>
                    </div>
                    <div class="modal-body">
                        <p>Your session is going to be expired in 5mins. Please press Continue to resume the session. </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" id="modalClose" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" v-on:click="resetTimer()" data-dismiss="modal">Continue</button>
                    </div>
                </div>
            </div>
        </div>
        <body class="d-flex flex-column h-100" id="home">
            <header>
                <nav class="navbar navbar-header">
                    <span class="navbar-text p-0">
                        <a href="/" v-on:click="navigateDashboard()">
                            <img class="ey-logo" src="../../assets/ey-logo.png" width="35" height="35" alt="EY">
                        </a>
                        <p class="navbar-text mb-0 text-left text-white v-top" style="margin-left: 10px;font-size: 20px;font-family: sans-serif;">Direct Tax Compliance  {{displayAppName}}</p>
                    </span>
                    <span class="navbar-text ham-bar" style="margin-bottom:25px;">
                        <div class="userprofile-group">
                            <div class="userprofile__dropdown">
                                <a class="nav-link dropdown-toggle" style=" color: white" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <font-awesome-icon :icon="['fas', 'user-alt']" class="icon userAlt" style="width:16px;height:16px;" />
                                    <span class="ft-14">
                                        &nbsp;&nbsp;{{loggedUser}}
                                    </span>
                                </a>
                                <div class="dropdown dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                    <a class="dropdown-item" aria-label="Press enter to open Help link" title="Help link" :href="userManualFilePath" target="_blank">
                                        <font-awesome-icon :icon="['fas', 'file-download']" class="icon fileDownload" style="width:16px;height:16px;" />
                                        &nbsp;&nbsp;Help
                                    </a>
                                    <a class="dropdown-item" aria-label="Press enter to open Dashboard page" title="Dashboard page link" href="#" v-if="showadashboardlink" v-on:click="navigateDashboard()">

                                        <font-awesome-icon :icon="['fas', 'home']" class="icon home" style="width:16px;height:16px;" />
                                        &nbsp;&nbsp;Dashboard
                                    </a>
                                    <a class="dropdown-item" aria-label="Press enter to open Admin page" title="Admin page link" href="#" v-if="showadminlink" v-on:click="navigateAdmin()">

                                        <font-awesome-icon :icon="['fas', 'user-cog']" class="icon userCog" style="width:16px;height:16px;" />
                                        &nbsp;&nbsp;Admin
                                    </a>
                                    <a class="dropdown-item" aria-label="Press enter to open Memo History page" title="Memo History page link" href="#" v-if="showmemohistorylink" v-on:click="navigateMemoHistory()">Memo History</a>
                                    <a class="dropdown-item" aria-label="Press enter to open Reconciliation page" title="Reconciliation page link" href="#" v-if="showauserlink" v-on:click="navigateUser()">

                                        <font-awesome-icon :icon="['fas', 'book']" class="icon book" style="width:16px;height:16px;" />
                                        &nbsp;&nbsp;Reconciliation
                                    </a>
                                    <a class="dropdown-item" aria-label="Press enter to open Admin Dashboard page" title="Admin Dashboard link" href="#" v-if="showadmindashboard" v-on:click="navigateAdminDashboard()">

                                        <font-awesome-icon :icon="['fas', 'user-shield']" class="icon userShield" style="width:16px;height:16px;" />
                                        &nbsp;&nbsp;Admin Dashboard
                                    </a>
                                    <a class="dropdown-item" aria-label="Press enter to Logout" title="Logout link" href="#" v-on:click="$msal.signOut()">

                                        <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="icon signOutAlt" style="width:16px;height:16px;" />
                                        &nbsp;&nbsp;Logout
                                    </a>
                                </div>
                            </div>
                        </div>
                    </span>
                </nav>
            </header>
        </body>
    </div>
</template>
<script>
    import {
        TimeOutDuration,
        WarningTimeoutDuration
    } from "../../services/constants";
    import $ from "jquery";
    export default {
        name: 'Navbar',
        data() {
            return {
                events: ['click', 'mousemove', 'mousedown', 'scroll', 'keydown', 'keypress', 'resize', 'load'],
                warningTimer: null,
                logoutTimer: null,
                showadminlink: false,
                showauserlink: false,
                showadashboardlink: false,
                showmemohistorylink: false,
                userManualFilePath: './BankRecon_Manual.pdf',
                showadmindashboard: false,
                displayAppName: null

            }
        },
        watch: {
            '$route'() {
                this.loggedUser = localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastName');
                this.showadashboardlink = true;
                if (this.$route.path.match(/Admin/g)) {
                    this.showadminlink = false;
                    this.bindAdminDashboardLink();
                    if (localStorage.getItem('appName') == 'BRC' && this.$route.name.match('ACRAdmin')) {
                        this.showauserlink = true;
                    }
                    this.showmemohistorylink = false;
                }
                else if (this.$route.path.match(/HomeAD/g) || this.$route.name.match('HomeAD')) {
                    this.displayAppName = null;
                    document.title = "EY-DTC";
                    this.userManualFilePath = "./BankRecon_Manual.pdf";
                    this.showadminlink = false;
                    this.showauserlink = false;
                    this.showadashboardlink = false;
                    this.showmemohistorylink = false;
                    if (localStorage.getItem('role') == 'admin') {
                        this.showadmindashboard = true;
                    }
                }
                else if (this.$route.name.match('UserCreation')) {
                    this.showadmindashboard = true;
                }
                else {
                    this.bindHelpLink();
                }
            }
        },
        created: function () {
            this.showadashboardlink = true;
            this.loggedUser = localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastName');
            if (localStorage.getItem('role') == 'admin') {
                if (this.$route.path.match(/Admin/g)) {
                    this.showadminlink = false;
                    this.bindAdminDashboardLink();
                    if (localStorage.getItem('appName') == 'BRC') {
                        this.showauserlink = true;
                    }
                } else {
                    this.bindHelpLink();
                    this.showadmindashboard = true;
                }
            }
            else {
                this.bindHelpLink();
            }
            if (this.$route.path.match(/HomeAD/g) || this.$route.name.match('HomeAD')) {
                this.showadminlink = false;
                this.showauserlink = false;
                this.showadashboardlink = false;
                this.showmemohistorylink = false;
                this.displayAppName = null;
                document.title = "EY-DTC";
                this.userManualFilePath = "./BankRecon_Manual.pdf";
            }
        },
        mounted() {
            this.events.forEach(function (event) {
                window.addEventListener(event, this.resetTimer)
            }, this);

            this.setTimer();
        },
        destroyed() {
            this.events.forEach(function (event) {
                window.removeEventListener(event, this.resetTimer)
            }, this);

            this.resetTimer();
        },
        methods: {
            setTimer() {
                this.warningTimer = setTimeout(
                    this.warningMessages, WarningTimeoutDuration);
            },
            resetTimer() {
                clearTimeout(this.warningTimer);
                clearTimeout(this.logoutTimer);

                this.setTimer();
            },
            warningMessages() {
                $('#logoutWarning').modal('show');

                this.logoutTimer = setTimeout(
                    this.inActiveUserAction, TimeOutDuration);
            },
            inActiveUserAction() {
                $('#logoutWarning').modal('hide');
                this.$msal.signOut();

            },
            navigateAdmin() {
                if (localStorage.getItem('appName') == 'BRC' && localStorage.getItem('role') == 'admin') {
                    this.$router.push("/ACRAdmin");
                }
            },
            navigateUser() {
                if (localStorage.getItem('appName') == 'BRC' || localStorage.getItem('role') == 'user') {
                    this.$router.push("/ACRHome");
                }
            },
            navigateDashboard() {
                this.$router.push("/");
            },
            navigateMemoHistory() {
                this.$router.push("/MEMOAdmin");
            },
            navigateAdminDashboard() {
                this.$router.push("/AdminDashboard");
            },
            bindHelpLink() {
                this.showadmindashboard = false;
                if (localStorage.getItem('appName') == 'BRC') // Since ACR is only having admin end currently
                {
                    this.userManualFilePath = "./BankRecon_Manual.pdf";
                    this.displayAppName = "| Bank-ERP Recon.";
                    document.title = "DTC Bank-ERP Recon.";
                    if (localStorage.getItem('role') == 'admin') {
                        this.showadminlink = true;
                        this.showauserlink = false;
                    } else {
                        this.showadminlink = false;
                        this.showauserlink = false;
                    }

                }
                else if (localStorage.getItem('appName') == 'CIT') {
                    this.displayAppName = "| CIT";
                    document.title = "DTC CIT";
                    this.userManualFilePath = "./CIT_Manual.pdf";
                }
                else if (localStorage.getItem('appName') == 'MEMO') {
                    this.displayAppName = "| MEMO";
                    document.title = "DTC MEMO";
                    this.userManualFilePath = "./Memo_Manual.pdf";
                    this.showmemohistorylink = true;
                }
                else if (localStorage.getItem('appName') == 'USBRGAAP') {
                    this.displayAppName = "| USBRGAAP";
                    document.title = "DTC USBRGAAP";
                    this.userManualFilePath = "./USBRGAAP_Manual.pdf";
                }
            },
            bindAdminDashboardLink() {
                if (this.$route.name.match('AdminDashboard')) {
                    this.showadmindashboard = false;
                    this.displayAppName = null;
                    document.title = "EY-DTC";
                }
                else {
                    if (this.$route.path.match(/HomeAD/g) || this.$route.name.match('HomeAD')) {
                        if (localStorage.getItem('role') == 'admin') {
                            this.showadmindashboard = true;
                        }
                        else
                            this.showadmindashboard = false;
                    }
                    else
                        this.showadmindashboard = true;
                }
            }
        }
    };
</script>
<style scoped>
    .dropdown:hover > .dropdown-menu {
        display: block;
    }

    .dropdown > .dropdown-menu {
        cursor: pointer;
        padding: 0.9rem 2rem;
        margin: -0.7rem 1.5rem 0;
        text-align: center;
        background: #fff;
        border: 1px solid #2e2e38;
        border-radius: 0;
        box-shadow: -0.125rem -0.125rem 0.3125rem 0 rgba(26,26,36,.2);
        min-width: 11.5rem;
    }

    .dropdown-item {
        display: block;
        width: 100%;
        padding: .25rem 1.5rem;
        clear: both;
        font-weight: 400;
        color: #212529;
        text-align: inherit;
        white-space: nowrap;
        background-color: transparent;
        border: 0;
    }

    .userprofile__dropdown {
        border: none;
        height: 2.813rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-top: 0;
        background: #2e2e38;
        display: inline-flex !important;
    }

    .userprofile-group {
        background-color: transparent;
        border: none;
        height: 2.813rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-top: 0;
        margin-right: 3.3125rem;
        position: absolute;
        right: 0;
    }
</style>
